import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full mb-8">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-brand-primary">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-brand-primary">
          {Math.round(progress)}%
        </span>
      </div>
      
      <div className="w-full bg-brand-gray rounded-full h-3 overflow-hidden">
        <motion.div
          className="h-full bg-gradient-to-r from-brand-orange to-brand-primary rounded-full"
          initial={{ width: 0 }}
          animate={{ width: `${progress}%` }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        />
      </div>
      
      <div className="flex justify-between mt-2">
        {[...Array(totalSteps)].map((_, index) => (
          <div
            key={index}
            className={`w-4 h-4 rounded-full border-2 ${
              index < currentStep
                ? 'bg-brand-primary border-brand-primary'
                : index === currentStep - 1
                ? 'bg-brand-orange border-brand-orange animate-pulse-slow'
                : 'bg-brand-white border-brand-gray'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;